import React, { useEffect, useState } from 'react';

import { AppBar, Toolbar, } from '@mui/material';
import { callApi } from '../../pages/commonapicall/fetchdata';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import { Close } from '@mui/icons-material';
import { tokens } from '../../theme/theme';

import PersonSearchIcon from '@mui/icons-material/PersonSearch';

import { API_ENDPOINTS } from '../../config/api/apiCall';

import CallAlertBar from '../../Layout/Alertbar';
import {
  Table,
  TableBody,
  
  TableCell,
  Grid,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  
  Box,
  useTheme,
  CssBaseline,
 
  IconButton,
  Tooltip,
  
  Typography,
  
} from '@mui/material';
import { useNavigate } from "react-router-dom";
import {  Delete, } from '@mui/icons-material';

import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';

import Subscriptionmodel from './Subscriptionmodel';
import AddUpdateCompany from './AddUpdateCompany';

const CompanyManagement = () => {

  const [searchTerm, setSearchTerm] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [newUser, setNewUser] = useState({ company_id: '', company_name: '', company_identifier: '', company_addr_line1: '', company_addr_line2: '', company_addr_line3: '', company_country: '', company_email: '', company_status: 'true', company_unit: '', company_licencefrom: '', company_licenceto: '', company_mill_type: '', company_subcriptionmodel: '', company_dbname: 'papyrus_erp_v1', company_isdbshared: 'false', company_contactperson: '', company_contactphone: '',gstno:'' ,pincode:''});
  const [currentUserId, setCurrentUserId] = useState(null);
  const [errorMessages, setErrorMessages] = useState({});
  const theme = useTheme();
  const navigate = useNavigate();
  const colors = tokens(theme.palette.mode);
  const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
  const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
  const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
  const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');
  const [isSubscriptionModelOpen, setIsSubscriptionModelOpen] = useState(false);
  const [companylist, setCompanylist] = useState([]);
  const [userRoles, setUserRoles] = useState([]);

  const LoadCompanyDetails = () => {

    callApi(API_ENDPOINTS.COMPANY_GetCompanyList, 'POST', { 'Content-Type': 'application/json' })
      .then(data => {
        // Update state with fetched data

        if (data.length > 0) {
          setCompanylist(data);

        }
        else {
          setParentRollSeverityvalue('warning');
          setParentRollMessageValue('No user data found..!');
          setParentRollAlertTitleValue('Warning');
          setParentRollMsgOpen(true);
        }
      })
      .catch(error => {
        // // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue('Unable to load the user details');
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
      });
  };

  const LoadRoleList = () => {
    let requestBody = {
      CompanyId: 1,
    };

    callApi(API_ENDPOINTS.USER_getUserRoles, 'POST', { 'Content-Type': 'application/json' }, requestBody)
      .then(data => {
        // Update state with fetched data

        if (data.length > 0) {
          setUserRoles(data);
        }
        else {
          setParentRollSeverityvalue('warning');
          setParentRollMessageValue('No user roles data found..!');
          setParentRollAlertTitleValue('Warning');
          setParentRollMsgOpen(true);
        }
      })
      .catch(error => {
        // // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue('Unable to load user role details');
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
      });
  };

  useEffect(() => {
    LoadCompanyDetails();
    LoadRoleList();
  }, []);



  const handleAddCompanyDetails = () => {
    setNewUser([]);

    setIsEditModalOpen(true);
    setCompanyList(false);
    setIsSubscriptionModelOpen(false);

  }

  const handleOpenSubscriptionModel = () => {
    setNewUser([]);
    setIsEditModalOpen(false);
    setCompanyList(false);
    setIsSubscriptionModelOpen(true);

  }

  const handleEditCompanyDetails = (user) => {
    setNewUser(user);
    setCurrentUserId(user.id);
    setIsEditModalOpen(true);
    setCompanyList(false);
    setIsSubscriptionModelOpen(false);
  }

  const handleDeleteCompany = (user) => {

    if (window.confirm(`Are you sure you want to delete this company (${user.company_name}) ?`)) {
      let requestBody = {
        company_id: user.company_id,
        company_identifier: user.company_identifier,
      };

      callApi(API_ENDPOINTS.COMPANY_deleteCompanyDetails, 'POST', { 'Content-Type': 'application/json' }, requestBody)
        .then(data => {
          // Update state with fetched data

          if (data.length > 0) {
            setParentRollSeverityvalue('info');
            setParentRollMessageValue(data);
            setParentRollAlertTitleValue('Info');
            setParentRollMsgOpen(true);
            LoadCompanyDetails();
          }
          else {
            setParentRollSeverityvalue('error');
            setParentRollMessageValue('Unable to delete the user');
            setParentRollAlertTitleValue('Error');
            setParentRollMsgOpen(true);
          }

        })
        .catch(error => {
          // // Update state with error message        
          setParentRollSeverityvalue('error');
          setParentRollMessageValue(error.message);
          setParentRollAlertTitleValue('Error');
          setParentRollMsgOpen(true);
        });
    }




  }




  const handleOpenUserList = (params, event) => {
    // const IndentId = params.row.IndentId;
    // const ConfirmationOrderId = params.row.ConfirmationOrderId;
    const company_id = params.company_id;

    const url = `/UserList/${company_id}`;
    //const url = `/newordercreate/${IndentId}/${ConfirmationOrderId}`;
    navigate(url);
  };





  const [CompanyList, setCompanyList] = useState(true);

  const handleBackToCompany = () => {
    navigate("/");
  }
  return (
    <Grid>

      {CompanyList && (
        <Grid container padding={1} spacing={1}>

          <CssBaseline />

          <AppBar position="static" sx={{ backgroundColor: "inherit" }}>
            <Toolbar>
              {/* First Menu */}
              <Typography variant="h4" gutterBottom>
               Organization Management
              </Typography>

              {/* Adding margin-left: auto to push the button to the right */}
              <Button size="small" variant="contained" onClick={() => handleAddCompanyDetails()} color="secondary" startIcon={<CorporateFareIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>New Company</Button>

              {/* <Button size="small" variant="contained" sx={{ ml: 1, textTransform: 'none' }} onClick={() => handleOpenSubscriptionModel()} startIcon={<MiscellaneousServicesIcon />} color="secondary">Subscription Model</Button> */}


              <Button size="small" variant="contained" onClick={() => handleOpenSubscriptionModel()} color="secondary" startIcon={<MiscellaneousServicesIcon />} sx={{ ml: 1, textTransform: 'none' }}>Subscription Model</Button>


              <IconButton onClick={handleBackToCompany} >
                <Close style={{ fontSize: "16px", color: "#2196F3" }} />
              </IconButton>

            </Toolbar>
          </AppBar>

          <CallAlertBar
            parentRollMsgOpen={parentRollMsgOpen}
            setParentRollMsgOpen={setParentRollMsgOpen}
            parentRollSeverityvalue={parentRollSeverityvalue}
            setParentRollSeverityvalue={setParentRollSeverityvalue}
            parentRollAlertTitleValue={parentRollAlertTitleValue}
            setParentRollAlertTitleValue={setParentRollAlertTitleValue}
            parentRollMessageValue={parentRollMessageValue}
            setParentRollMessageValue={setParentRollMessageValue}
          />



          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Box
              gridColumn="span 9"
              gridRow="span 2"
              alignItems="center"
              justifyContent="center"
              // padding={1}
              sx={{
                "& .MuiTable-root": {
                  border: "none",
                  size: "small",
                },
                "& .MuiTableCell-root": {
                  borderBottom: "none",
                  border: "1px solid",
                  borderColor: `${colors.primary[400]} !important`,
                  padding: "2px",  // Further reduced padding
                },
                "& .MuiTableHead-root": {
                  borderBottom: "none",
                },
                "& .MuiTableBody-root": {
                  overflowY: "auto",
                },
                "& .MuiCheckbox-root": {
                  color: `${colors.blueAccent[200]} !important`,
                  size: "small",
                },
                "& .MuiTableFooter-root": {
                  borderTop: "none",
                  backgroundColor: colors.blueAccent[700],
                  height: "10px",
                },
                "& .MuiButton-text": {
                  color: `${colors.grey[100]} !important`,
                },
                // scroll bar
                maxHeight: {
                  xs: '72vh', // Extra small devices (phones)
                  sm: '72vh', // Small devices (tablets)
                  md: '74vh', // Medium devices (small laptops)
                  lg: '80vh', // Large devices (desktops)
                  xl: '80vh', // Extra large devices (large desktops)
                },
                overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                '&::-webkit-scrollbar': {
                  width: '8px',
                },
                '&::-webkit-scrollbar-track': {
                  background: colors.primary[400],
                  borderRadius: '10px',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: colors.blueAccent[600],
                  borderRadius: '10px',
                  '&:hover': {
                    background: colors.blueAccent[800],
                  },
                },
                '&::-webkit-scrollbar-corner': {
                  background: colors.primary[700],
                }
              }}
            >
              <TableContainer>
                <Table size="small">
                  <TableHead sx={{ height: 30 }}>
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell>COMPANY NAME</TableCell>
                      <TableCell>ADDRESS LINE 1</TableCell>
                      <TableCell>ADDRESS LINE 2</TableCell>
                      <TableCell>ADDRESS LINE 3</TableCell>
                      <TableCell>COUNTRY</TableCell>
                      <TableCell>EMAIL</TableCell>
                      <TableCell>STATUS</TableCell>
                      <TableCell>ACTION</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {companylist.map((user) => (
                      <TableRow key={user.company_id}>

                        <TableCell>
                          <Tooltip title="User List">
                            <IconButton
                              color="secondary"

                              onClick={() => {
                                handleOpenUserList(user)
                              }}
                            >
                              <PersonSearchIcon />
                            </IconButton>
                          </Tooltip>
                        </TableCell>

                        <TableCell>
                          <span
                            style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                            onClick={() => handleEditCompanyDetails(user)}
                          >
                            {user.company_name}
                          </span>
                        </TableCell>


                        <TableCell>{user.company_addr_line1}</TableCell>
                        <TableCell>{user.company_addr_line2}</TableCell>
                        <TableCell>{user.company_addr_line3}</TableCell>
                        <TableCell>{user.company_country}</TableCell>
                        <TableCell>{user.company_email}</TableCell>
                        {/* <TableCell>{user.company_status}</TableCell> */}

                        <TableCell style={{ minWidth: 70 }}>{user.company_status ? 'Active' : 'Inactive'}</TableCell>


                        <TableCell>
                          {/* <IconButton
                            color="secondary"
                           
                            onClick={() => {
                              handleEditCompanyDetails(user)
                            }}
                          >
                            <Edit />
                          </IconButton> */}
                          <Tooltip title="Delete Company" >
                            <IconButton
                              color="secondary"

                              onClick={() => {
                                handleDeleteCompany(user)
                              }}
                            >
                              <Delete />
                            </IconButton>
                          </Tooltip>

                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>

        </Grid>

      )}

      {isEditModalOpen && (
        <AddUpdateCompany newUser={newUser} setNewUser={setNewUser} setIsEditModalOpen={setIsEditModalOpen}
          setCompanyList={setCompanyList} LoadCompanyDetails={LoadCompanyDetails} setIsSubscriptionModelOpen={setIsSubscriptionModelOpen}
        />
      )}
      {isSubscriptionModelOpen && (
        <Subscriptionmodel setIsEditModalOpen={setIsEditModalOpen}
          setCompanyList={setCompanyList} setIsSubscriptionModelOpen={setIsSubscriptionModelOpen}
        />
      )}

    </Grid>
  );
};

export default CompanyManagement;
